import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import MainLayout from "../layouts/MainLayout";

// Public pages
import Home from "../pages/Home";
import AboutPage from "../pages/About/AboutPage";

import BasketballCourt from "../pages/BasketballCourt/BasketballCourt";
import TennisCourt from "../pages/TennisCourt/TennisCourt";
import RunningTrack from "../pages/RunningTrack/RunningTrack";
import WoodenFlooring from "../pages/WoodenFlooring/WoodenFlooring";
import EpdmFlooring from "../pages/EpdmFlooring/EpdmFlooring";
import BadmintonCourt from "../pages/BadmintonCourt/BadmintonCourt";
import VolleyballCourt from "../pages/VolleyballCourt/VolleyballCourt";
import Footballfield from "../pages/Footballfield/Footballfield";
import PublicProjects from "../pages/Projects/Projects";
import PublicProjectDetails from "../pages/Projects/ProjectDetails";

import PublicGallery from "../pages/Gallery/Gallery";

import Blogs from "../pages/Blogs/Blogs";
import BlogDetails from "../pages/Blogs/BlogDetails";

import Contact from "../pages/Contact/Contact";

// Admin
import ProtectedRoute from "./ProtectedRoute";
import AdminLayout from "../admin/layouts/AdminLayout";

import Login from "../admin/pages/Login/Login";
import Dashboard from "../admin/pages/Dashboard/Dashboard";

import Projects from "../admin/pages/Projects/Projects";
import AddProject from "../admin/pages/Projects/AddProjects";
import ProjectDetails from "../admin/pages/Projects/ProjectDetails";
import EditProject from "../admin/pages/Projects/EditProject";

// import Services from "../admin/pages/Services/Services";
import Gallery from "../admin/pages/Gallery/Gallery";

import AdminBlogs from "../admin/pages/Blogs/Blogs";
import AddBlog from "../admin/pages/Blogs/AddBlog";
import EditBlog from "../admin/pages/Blogs/EditBlog";

import QuoteRequests from "../admin/pages/QuoteRequests/QuoteRequests";
import Settings from "../admin/pages/Settings/Settings";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        {/* ================= PUBLIC ================= */}

        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />

          {/* Projects */}
          <Route path="/projects" element={<PublicProjects />} />
          <Route path="/projects/:slug" element={<PublicProjectDetails />} />

          {/* Services */}
          <Route
            path="/services/basketball-court"
            element={<BasketballCourt />}
          />

          <Route path="/services/tennis-court" element={<TennisCourt />} />

          <Route path="/services/running-track" element={<RunningTrack />} />

          <Route
            path="/services/wooden-flooring"
            element={<WoodenFlooring />}
          />

          <Route path="/services/epdm-flooring" element={<EpdmFlooring />} />

          <Route
            path="/services/badminton-court"
            element={<BadmintonCourt />}
          />

          <Route
            path="/services/volleyball-court"
            element={<VolleyballCourt />}
          />

          <Route path="/services/football-field" element={<Footballfield />} />

          {/* Gallery */}
          <Route path="/gallery" element={<PublicGallery />} />

          {/* Blogs */}
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetails />} />

          {/* Contact */}
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* ================= ADMIN LOGIN ================= */}

        <Route path="/admin/login" element={<Login />} />

        {/* ================= PROTECTED ADMIN ================= */}

        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin/dashboard" element={<Dashboard />} />

            {/* Projects */}
            <Route path="/admin/projects" element={<Projects />} />

            <Route path="/admin/projects/add" element={<AddProject />} />

            <Route path="/admin/projects/:id/edit" element={<EditProject />} />

            <Route path="/admin/projects/:id" element={<ProjectDetails />} />

            {/* Services
            <Route path="/admin/services" element={<Services />} /> */}

            {/* Gallery */}
            <Route path="/admin/gallery" element={<Gallery />} />

            {/* Blogs */}
            <Route path="/admin/blogs" element={<AdminBlogs />} />

            <Route path="/admin/blogs/add" element={<AddBlog />} />

            <Route path="/admin/blogs/:id/edit" element={<EditBlog />} />

            {/* Quote Requests */}
            <Route path="/admin/quote-requests" element={<QuoteRequests />} />

            {/* Settings */}
            <Route path="/admin/settings" element={<Settings />} />
          </Route>
        </Route>

        {/* ================= 404 ================= */}

        <Route path="*" element={<div>404 - Page Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
